import { TriggerRoadSpeedSeverity } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/roadSpeed';
import { type Rule, RuleCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/rules';
import type { SessionUser } from '@cobliteam/common-types';

import { format } from '@cobliteam/utils/date';

import type { FormValues } from '../../../../types/triggerFormSchema';
import { DEFAULT_TRIGGER_FORM_VALUES } from '../../../../types/triggerFormValues';

export const createTriggerTemplate = (templateType: string, rules: Rule[], user: SessionUser): FormValues => {
  const templateRule = {
    road: RuleCategory.ROAD_SPEED_LIMIT,
    speed: RuleCategory.VEHICLE_SPEED_LIMIT,
    idle: RuleCategory.IDLE_ENGINE,
  }[templateType];

  const templateSeverity = {
    road: TriggerRoadSpeedSeverity.HIGHER,
    speed: undefined,
    idle: undefined,
  }[templateType];

  const template = {
    road: 'excesso de velocidade da via',
    speed: 'excesso de velocidade do veículo',
    idle: 'motor ocioso',
  }[templateType];

  const rule = rules?.find((rule) => rule.category === templateRule);
  const defaultCondition = rule?.conditions[0];
  const defaultStartTime = format(new Date().setHours(0, 0, 0), 'HH:mm:ss');
  const defaultEndTime = format(new Date().setHours(23, 59, 59), 'HH:mm:ss');

  const triggerTemplate: FormValues = {
    ...DEFAULT_TRIGGER_FORM_VALUES,
    name: `Regra de ${user.name} para ${template}`,
    notifiedUsersChannels: [
      {
        id: user.id,
        name: user.name,
        sendNotificationAppGestor: true,
        sendNotificationEmail: true,
        sendNotificationWebPainel: true,
      },
    ],
    rule: {
      id: rule?.id || '',
      category: rule?.category || '',
    },
    condition: { id: defaultCondition?.id || '', category: defaultCondition?.category || '' },
    minRoadSpeedSeverity: templateSeverity,
    vehicleGroups: DEFAULT_TRIGGER_FORM_VALUES.vehicleGroups.map((group) => ({
      ...group,
      path: group.path ?? '',
    })),
    vehicles: DEFAULT_TRIGGER_FORM_VALUES.vehicles.map((vehicle) => ({
      ...vehicle,
      groupPath: vehicle.groupPath ?? '',
    })),
    hour: {
      start: defaultStartTime,
      end: defaultEndTime,
    },
    requestVideo: false,
  };

  return triggerTemplate;
};
